<script>
import { CellGroup, Cell, Dialog } from 'vant'
import ImageViewer from '@/components/org/ImageViewer'
import GameTeamSuitPicker from '@/components/org/GameTeamSuitPicker'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-team-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'image-viewer': ImageViewer,
        'game-team-suit-picker': GameTeamSuitPicker,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            team: {
                id: null,
                matchGroupId: null,
                name: null,
                logoUrl: null,
                homeTeamSuit: null,
                awayTeamSuit: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEditBtnClick() {
            console.log('onEditBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditTeam',
                    params: { id: this.team.id },
                    query: { matchGroupId: this.team.matchGroupId }
                }
            })
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-team'],
                message: this.locale['delete-team-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete',
                    data: {
                        id: this.team.id,
                        matchGroupId: this.team.matchGroupId
                    }
                })
            }).catch(() => {
                // on cancel
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="team-detail">
        <van-cell-group>
            <van-cell :title="locale['team-name-label']" :value="team.name"/>
            <image-viewer
                :label="locale['team-logo-label']"
                :imageUrl="adjustImageSize(team.logoUrl, 160, 160)"
                :previewImageUrl="adjustImageSize(team.logoUrl, 750, 750)"
            />
        </van-cell-group>
        <van-cell-group class="t-outer-margin">
            <van-row>
                <van-col span="12">
                    <game-team-suit-picker
                        :label="locale['game-home-team-suit-label']"
                        :value="team.homeTeamSuit"
                        :readonly="true"
                    />
                </van-col>
                <van-col span="12">
                    <game-team-suit-picker
                        :label="locale['game-away-team-suit-label']"
                        :value="team.awayTeamSuit"
                        :readonly="true"
                    />
                </van-col>
            </van-row>
        </van-cell-group>
        <bottom-toolbar 
            type="button-button" 
            :mainButtonLabel="locale['edit']"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onEditBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>